import { render, staticRenderFns } from "./ElementarySchoolNaturalCourse.vue?vue&type=template&id=024036f7&scoped=true&"
import script from "./ElementarySchoolNaturalCourse.vue?vue&type=script&lang=js&"
export * from "./ElementarySchoolNaturalCourse.vue?vue&type=script&lang=js&"
import style0 from "./ElementarySchoolNaturalCourse.vue?vue&type=style&index=0&id=024036f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024036f7",
  null
  
)

export default component.exports